/** Hands a presigned URL to the browser. It answers with Content-Disposition:
 *  attachment, so the page stays put and the file never passes through JS. */
export function triggerDownload(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';
  link.hidden = true;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
